import '@/components/MapOverview/map.css';
import 'mapbox-gl/dist/mapbox-gl.css';

import React, { ComponentProps } from 'react';
import { Map as MapGlMap, MapRef } from 'react-map-gl';

import { DEFAULT_MAP_STYLE, MAPBOX_TOKEN } from '@/config/constants';
import { fontFamily } from '@/theme/fontFamily';

export const Map = React.forwardRef<MapRef, ComponentProps<typeof MapGlMap>>(({ style, ...delegated }, ref) => {
  const handleTransformRequest = (url: string) => {
    if (url.includes('mapserver.landler.io')) {
      return {
        url,
        credentials: 'include' as const,
      };
    }
    return { url };
  };

  return (
    <MapGlMap
      ref={ref}
      mapStyle={DEFAULT_MAP_STYLE}
      mapboxAccessToken={MAPBOX_TOKEN}
      dragRotate={false}
      touchPitch={false}
      cursor='default'
      style={{ fontFamily: fontFamily.sans, ...style }}
      logoPosition='bottom-right'
      attributionControl={false}
      transformRequest={handleTransformRequest}
      {...delegated}
    />
  );
});
Map.displayName = 'Map';

export * from './hooks/useJustifyMap';
